import { render, staticRenderFns } from "./TransitionScreen.vue?vue&type=template&id=db10e738&"
import script from "./TransitionScreen.vue?vue&type=script&lang=js&"
export * from "./TransitionScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports